(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-jss"), require("hoist-non-react-statics"), require("@bingads-webui-react/hoc-utils"), require("underscore"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "react-jss", "hoist-non-react-statics", "@bingads-webui-react/hoc-utils", "underscore"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("react"), require("react-jss"), require("hoist-non-react-statics"), require("@bingads-webui-react/hoc-utils"), require("underscore")) : factory(root["react"], root["react-jss"], root["hoist-non-react-statics"], root["@bingads-webui-react/hoc-utils"], root["underscore"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__3__, __WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__5__, __WEBPACK_EXTERNAL_MODULE__6__, __WEBPACK_EXTERNAL_MODULE__8__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "withDefaultStyles", {
  enumerable: true,
  get: function get() {
    return _withDefaultStyles.withDefaultStyles;
  }
});
Object.defineProperty(exports, "useDefaultStyles", {
  enumerable: true,
  get: function get() {
    return _useDefaultStyles.useDefaultStyles;
  }
});

var _withDefaultStyles = __webpack_require__(2);

var _useDefaultStyles = __webpack_require__(7);

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withDefaultStyles = withDefaultStyles;

var _react = _interopRequireDefault(__webpack_require__(3));

var _reactJss = _interopRequireWildcard(__webpack_require__(4));

var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(5));

var _hocUtils = __webpack_require__(6);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const emptyTheme = {};

function withDefaultStyles(WrappedComponent, getStyles = () => ({})) {
  const StyledComponent = (0, _reactJss.default)(({
    components = {},
    core = {}
  }) => getStyles(components, core))(WrappedComponent);

  const HOC = props => _react.default.createElement(_reactJss.ThemeProvider, {
    theme: emptyTheme
  }, _react.default.createElement(StyledComponent, props));

  HOC.displayName = `withDefaultStyles(${(0, _hocUtils.getDisplayName)(WrappedComponent)})`;
  (0, _hoistNonReactStatics.default)(HOC, WrappedComponent);
  return HOC;
}

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__3__;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__5__;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__6__;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDefaultStyles = useDefaultStyles;

var _underscore = _interopRequireDefault(__webpack_require__(8));

var _react = __webpack_require__(3);

var _reactJss = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const emptyTheme = {};
const defaultProps = {};

const defaultGetStyles = () => ({});

function useDeepMemo(value) {
  const ref = (0, _react.useRef)(null);

  if (!_underscore.default.isEqual(value, ref.current)) {
    ref.current = value;
  }

  return ref.current;
}

function useDefaultStyles(getStyles = defaultGetStyles, props = defaultProps) {
  const theme = (0, _reactJss.useTheme)();
  const useStyles = (0, _react.useMemo)(() => {
    const _ref = theme || emptyTheme,
          _ref$components = _ref.components,
          components = _ref$components === void 0 ? {} : _ref$components,
          _ref$core = _ref.core,
          core = _ref$core === void 0 ? {} : _ref$core;

    return (0, _reactJss.createUseStyles)(getStyles(components, core));
  }, [getStyles, theme]);
  const classes = useStyles(props); // useDeepMemo to prevent hooks from re-running if the classes object changes reference
  // however the content doesn't change

  return useDeepMemo(classes);
}

/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__8__;

/***/ })
/******/ ]);
});
